// @generated by protoc-gen-es v2.6.2 with parameter "target=ts"
// @generated from file bff/v1/common.proto (package bff.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { CompanyAllowedMailDomain, EmailVerifiedStatus, Language, License, Member, Organization, Plan, Product, SessionInformation, UserRole, UserRoleSetting } from "./model_pb";
import { file_bff_v1_model } from "./model_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bff/v1/common.proto.
 */
export const file_bff_v1_common: GenFile = /*@__PURE__*/
  fileDesc("ChNiZmYvdjEvY29tbW9uLnByb3RvEgZiZmYudjEizgEKGFNhdmVNZW1iZXJQcm9maWxlUmVxdWVzdBIKCgJpZBgBIAEoCRIXCg9vcmdhbml6YXRpb25faWQYAiABKAkSFAoMcGhvbmVfbnVtYmVyGAMgASgJEhUKDW1vYmlsZV9udW1iZXIYBCABKAkSDAoEbmFtZRgFIAEoCRIiCghsYW5ndWFnZRgGIAEoDjIQLmJmZi52MS5MYW5ndWFnZRIZCgxlbmdsaXNoX25hbWUYByABKAlIAIgBAToCGAFCDwoNX2VuZ2xpc2hfbmFtZSI/ChlTYXZlTWVtYmVyUHJvZmlsZVJlc3BvbnNlEh4KBm1lbWJlchgBIAEoCzIOLmJmZi52MS5NZW1iZXI6AhgBIqoBCh1VcGRhdGVPd25NZW1iZXJQcm9maWxlUmVxdWVzdBIUCgxwaG9uZV9udW1iZXIYASABKAkSFQoNbW9iaWxlX251bWJlchgCIAEoCRIMCgRuYW1lGAMgASgJEiIKCGxhbmd1YWdlGAQgASgOMhAuYmZmLnYxLkxhbmd1YWdlEhkKDGVuZ2xpc2hfbmFtZRgFIAEoCUgAiAEBQg8KDV9lbmdsaXNoX25hbWUiQAoeVXBkYXRlT3duTWVtYmVyUHJvZmlsZVJlc3BvbnNlEh4KBm1lbWJlchgBIAEoCzIOLmJmZi52MS5NZW1iZXIiGQoXR2V0TWVtYmVyUHJvZmlsZVJlcXVlc3QiOgoYR2V0TWVtYmVyUHJvZmlsZVJlc3BvbnNlEh4KBm1lbWJlchgBIAEoCzIOLmJmZi52MS5NZW1iZXIiFQoTTGlzdFByb2R1Y3RzUmVxdWVzdCI5ChRMaXN0UHJvZHVjdHNSZXNwb25zZRIhCghwcm9kdWN0cxgBIAMoCzIPLmJmZi52MS5Qcm9kdWN0IiQKFkdldE9yZ2FuaXphdGlvblJlcXVlc3QSCgoCaWQYASABKAkiRQoXR2V0T3JnYW5pemF0aW9uUmVzcG9uc2USKgoMb3JnYW5pemF0aW9uGAEgASgLMhQuYmZmLnYxLk9yZ2FuaXphdGlvbiInChRMaXN0VXNlclJvbGVzUmVxdWVzdBIPCgdwbGFuX2lkGAEgASgFIj0KFUxpc3RVc2VyUm9sZXNSZXNwb25zZRIkCgp1c2VyX3JvbGVzGAEgAygLMhAuYmZmLnYxLlVzZXJSb2xlIiAKHkxpc3RTZWxlY3RhYmxlVXNlclJvbGVzUmVxdWVzdCJcCh9MaXN0U2VsZWN0YWJsZVVzZXJSb2xlc1Jlc3BvbnNlEjkKFXNlbGVjdGFibGVfdXNlcl9yb2xlcxgBIAMoCzIaLmJmZi52MS5TZWxlY3RhYmxlVXNlclJvbGUiLAoZR2V0UHJvZHVjdEJ5UGxhbklkUmVxdWVzdBIPCgdwbGFuX2lkGAEgASgFIj4KGkdldFByb2R1Y3RCeVBsYW5JZFJlc3BvbnNlEiAKB3Byb2R1Y3QYASABKAsyDy5iZmYudjEuUHJvZHVjdCIcCg5HZXRQbGFuUmVxdWVzdBIKCgJpZBgBIAEoBSItCg9HZXRQbGFuUmVzcG9uc2USGgoEcGxhbhgBIAEoCzIMLmJmZi52MS5QbGFuImoKElNlbGVjdGFibGVVc2VyUm9sZRIgCgdsaWNlbnNlGAEgASgLMg8uYmZmLnYxLkxpY2Vuc2USMgoRdXNlcl9yb2xlX3NldHRpbmcYAiADKAsyFy5iZmYudjEuVXNlclJvbGVTZXR0aW5nIhQKEkxpc3RNZW1iZXJzUmVxdWVzdCI2ChNMaXN0TWVtYmVyc1Jlc3BvbnNlEh8KB21lbWJlcnMYASADKAsyDi5iZmYudjEuTWVtYmVyIikKGFVwbG9hZE1lbWJlckltYWdlUmVxdWVzdBINCgVpbWFnZRgBIAEoDCIuChlVcGxvYWRNZW1iZXJJbWFnZVJlc3BvbnNlEhEKCWltYWdlX3VybBgBIAEoCSI4CiNHZXRDb21wYW55QWxsb3dlZE1haWxEb21haW5zUmVxdWVzdBIRCgljb21wYW55SWQYASABKAkiZQokR2V0Q29tcGFueUFsbG93ZWRNYWlsRG9tYWluc1Jlc3BvbnNlEj0KE2FsbG93ZWRfbWFpbF9kb21haW4YASABKAsyIC5iZmYudjEuQ29tcGFueUFsbG93ZWRNYWlsRG9tYWluIiIKFEVtYWlsVmVyaWZpZWRSZXF1ZXN0EgoKAmlkGAEgASgJIkQKFUVtYWlsVmVyaWZpZWRSZXNwb25zZRIrCgZzdGF0dXMYASABKA4yGy5iZmYudjEuRW1haWxWZXJpZmllZFN0YXR1cyIVChNMaXN0U2Vzc2lvbnNSZXF1ZXN0IkQKFExpc3RTZXNzaW9uc1Jlc3BvbnNlEiwKCHNlc3Npb25zGAEgAygLMhouYmZmLnYxLlNlc3Npb25JbmZvcm1hdGlvbiIrChRGaW5pc2hTZXNzaW9uUmVxdWVzdBITCgtzZXNzaW9uX2tleRgBIAEoCSIXChVGaW5pc2hTZXNzaW9uUmVzcG9uc2Uy5AkKEEJmZkNvbW1vblNlcnZpY2USSwoMTGlzdFByb2R1Y3RzEhsuYmZmLnYxLkxpc3RQcm9kdWN0c1JlcXVlc3QaHC5iZmYudjEuTGlzdFByb2R1Y3RzUmVzcG9uc2UiABJdChJHZXRQcm9kdWN0QnlQbGFuSWQSIS5iZmYudjEuR2V0UHJvZHVjdEJ5UGxhbklkUmVxdWVzdBoiLmJmZi52MS5HZXRQcm9kdWN0QnlQbGFuSWRSZXNwb25zZSIAEk4KDUxpc3RVc2VyUm9sZXMSHC5iZmYudjEuTGlzdFVzZXJSb2xlc1JlcXVlc3QaHS5iZmYudjEuTGlzdFVzZXJSb2xlc1Jlc3BvbnNlIgASbAoXTGlzdFNlbGVjdGFibGVVc2VyUm9sZXMSJi5iZmYudjEuTGlzdFNlbGVjdGFibGVVc2VyUm9sZXNSZXF1ZXN0GicuYmZmLnYxLkxpc3RTZWxlY3RhYmxlVXNlclJvbGVzUmVzcG9uc2UiABJXChBHZXRNZW1iZXJQcm9maWxlEh8uYmZmLnYxLkdldE1lbWJlclByb2ZpbGVSZXF1ZXN0GiAuYmZmLnYxLkdldE1lbWJlclByb2ZpbGVSZXNwb25zZSIAEmkKFlVwZGF0ZU93bk1lbWJlclByb2ZpbGUSJS5iZmYudjEuVXBkYXRlT3duTWVtYmVyUHJvZmlsZVJlcXVlc3QaJi5iZmYudjEuVXBkYXRlT3duTWVtYmVyUHJvZmlsZVJlc3BvbnNlIgASVAoPR2V0T3JnYW5pemF0aW9uEh4uYmZmLnYxLkdldE9yZ2FuaXphdGlvblJlcXVlc3QaHy5iZmYudjEuR2V0T3JnYW5pemF0aW9uUmVzcG9uc2UiABI8CgdHZXRQbGFuEhYuYmZmLnYxLkdldFBsYW5SZXF1ZXN0GhcuYmZmLnYxLkdldFBsYW5SZXNwb25zZSIAEkgKC0xpc3RNZW1iZXJzEhouYmZmLnYxLkxpc3RNZW1iZXJzUmVxdWVzdBobLmJmZi52MS5MaXN0TWVtYmVyc1Jlc3BvbnNlIgASWgoRVXBsb2FkTWVtYmVySW1hZ2USIC5iZmYudjEuVXBsb2FkTWVtYmVySW1hZ2VSZXF1ZXN0GiEuYmZmLnYxLlVwbG9hZE1lbWJlckltYWdlUmVzcG9uc2UiABJ7ChxHZXRDb21wYW55QWxsb3dlZE1haWxEb21haW5zEisuYmZmLnYxLkdldENvbXBhbnlBbGxvd2VkTWFpbERvbWFpbnNSZXF1ZXN0GiwuYmZmLnYxLkdldENvbXBhbnlBbGxvd2VkTWFpbERvbWFpbnNSZXNwb25zZSIAEk4KDUVtYWlsVmVyaWZpZWQSHC5iZmYudjEuRW1haWxWZXJpZmllZFJlcXVlc3QaHS5iZmYudjEuRW1haWxWZXJpZmllZFJlc3BvbnNlIgASSwoMTGlzdFNlc3Npb25zEhsuYmZmLnYxLkxpc3RTZXNzaW9uc1JlcXVlc3QaHC5iZmYudjEuTGlzdFNlc3Npb25zUmVzcG9uc2UiABJOCg1GaW5pc2hTZXNzaW9uEhwuYmZmLnYxLkZpbmlzaFNlc3Npb25SZXF1ZXN0Gh0uYmZmLnYxLkZpbmlzaFNlc3Npb25SZXNwb25zZSIAQokBCgpjb20uYmZmLnYxQgtDb21tb25Qcm90b1ABWjVnaXRodWIuY29tL2VuZWNoYWluL2VjbG91ZC9iZmYvZ2VuL3Byb3RvL2JmZi92MTtiZmZ2MaICA0JYWKoCBkJmZi5WMcoCBkJmZlxWMeICEkJmZlxWMVxHUEJNZXRhZGF0YeoCB0JmZjo6VjFiBnByb3RvMw", [file_bff_v1_model]);

/**
 * メンバープロフィール保存のリクエスト
 *
 * @generated from message bff.v1.SaveMemberProfileRequest
 * @deprecated
 */
export type SaveMemberProfileRequest = Message<"bff.v1.SaveMemberProfileRequest"> & {
  /**
   * メンバーID
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * 所属組織ID
   *
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * メンバーの電話番号
   *
   * @generated from field: string phone_number = 3;
   */
  phoneNumber: string;

  /**
   * メンバーの携帯電話番号
   *
   * @generated from field: string mobile_number = 4;
   */
  mobileNumber: string;

  /**
   * メンバー名
   *
   * @generated from field: string name = 5;
   */
  name: string;

  /**
   * 言語設定
   *
   * @generated from field: bff.v1.Language language = 6;
   */
  language: Language;

  /**
   * メンバー名(英語表記)
   *
   * @generated from field: optional string english_name = 7;
   */
  englishName?: string;
};

/**
 * Describes the message bff.v1.SaveMemberProfileRequest.
 * Use `create(SaveMemberProfileRequestSchema)` to create a new message.
 * @deprecated
 */
export const SaveMemberProfileRequestSchema: GenMessage<SaveMemberProfileRequest> = /*@__PURE__*/
  messageDesc(file_bff_v1_common, 0);

/**
 * メンバープロフィール保存のレスポンス
 *
 * @generated from message bff.v1.SaveMemberProfileResponse
 * @deprecated
 */
export type SaveMemberProfileResponse = Message<"bff.v1.SaveMemberProfileResponse"> & {
  /**
   * @generated from field: bff.v1.Member member = 1;
   */
  member?: Member;
};

/**
 * Describes the message bff.v1.SaveMemberProfileResponse.
 * Use `create(SaveMemberProfileResponseSchema)` to create a new message.
 * @deprecated
 */
export const SaveMemberProfileResponseSchema: GenMessage<SaveMemberProfileResponse> = /*@__PURE__*/
  messageDesc(file_bff_v1_common, 1);

/**
 * 自身のプロフィール更新のリクエスト
 *
 * @generated from message bff.v1.UpdateOwnMemberProfileRequest
 */
export type UpdateOwnMemberProfileRequest = Message<"bff.v1.UpdateOwnMemberProfileRequest"> & {
  /**
   * メンバーの電話番号
   *
   * @generated from field: string phone_number = 1;
   */
  phoneNumber: string;

  /**
   * メンバーの携帯電話番号
   *
   * @generated from field: string mobile_number = 2;
   */
  mobileNumber: string;

  /**
   * メンバー名
   *
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * 言語設定
   *
   * @generated from field: bff.v1.Language language = 4;
   */
  language: Language;

  /**
   * メンバー名(英語表記)
   *
   * @generated from field: optional string english_name = 5;
   */
  englishName?: string;
};

/**
 * Describes the message bff.v1.UpdateOwnMemberProfileRequest.
 * Use `create(UpdateOwnMemberProfileRequestSchema)` to create a new message.
 */
export const UpdateOwnMemberProfileRequestSchema: GenMessage<UpdateOwnMemberProfileRequest> = /*@__PURE__*/
  messageDesc(file_bff_v1_common, 2);

/**
 * メンバープロフィール更新のレスポンス
 *
 * @generated from message bff.v1.UpdateOwnMemberProfileResponse
 */
export type UpdateOwnMemberProfileResponse = Message<"bff.v1.UpdateOwnMemberProfileResponse"> & {
  /**
   * @generated from field: bff.v1.Member member = 1;
   */
  member?: Member;
};

/**
 * Describes the message bff.v1.UpdateOwnMemberProfileResponse.
 * Use `create(UpdateOwnMemberProfileResponseSchema)` to create a new message.
 */
export const UpdateOwnMemberProfileResponseSchema: GenMessage<UpdateOwnMemberProfileResponse> = /*@__PURE__*/
  messageDesc(file_bff_v1_common, 3);

/**
 * メンバープロフィール取得のリクエスト
 *
 * @generated from message bff.v1.GetMemberProfileRequest
 */
export type GetMemberProfileRequest = Message<"bff.v1.GetMemberProfileRequest"> & {
};

/**
 * Describes the message bff.v1.GetMemberProfileRequest.
 * Use `create(GetMemberProfileRequestSchema)` to create a new message.
 */
export const GetMemberProfileRequestSchema: GenMessage<GetMemberProfileRequest> = /*@__PURE__*/
  messageDesc(file_bff_v1_common, 4);

/**
 * メンバープロフィール取得のレスポンス
 *
 * @generated from message bff.v1.GetMemberProfileResponse
 */
export type GetMemberProfileResponse = Message<"bff.v1.GetMemberProfileResponse"> & {
  /**
   * @generated from field: bff.v1.Member member = 1;
   */
  member?: Member;
};

/**
 * Describes the message bff.v1.GetMemberProfileResponse.
 * Use `create(GetMemberProfileResponseSchema)` to create a new message.
 */
export const GetMemberProfileResponseSchema: GenMessage<GetMemberProfileResponse> = /*@__PURE__*/
  messageDesc(file_bff_v1_common, 5);

/**
 * プロダクト一覧取得のリクエスト
 *
 * @generated from message bff.v1.ListProductsRequest
 */
export type ListProductsRequest = Message<"bff.v1.ListProductsRequest"> & {
};

/**
 * Describes the message bff.v1.ListProductsRequest.
 * Use `create(ListProductsRequestSchema)` to create a new message.
 */
export const ListProductsRequestSchema: GenMessage<ListProductsRequest> = /*@__PURE__*/
  messageDesc(file_bff_v1_common, 6);

/**
 * プロダクト一覧取得のレスポンス
 *
 * @generated from message bff.v1.ListProductsResponse
 */
export type ListProductsResponse = Message<"bff.v1.ListProductsResponse"> & {
  /**
   * @generated from field: repeated bff.v1.Product products = 1;
   */
  products: Product[];
};

/**
 * Describes the message bff.v1.ListProductsResponse.
 * Use `create(ListProductsResponseSchema)` to create a new message.
 */
export const ListProductsResponseSchema: GenMessage<ListProductsResponse> = /*@__PURE__*/
  messageDesc(file_bff_v1_common, 7);

/**
 * 組織取得のリクエスト
 *
 * @generated from message bff.v1.GetOrganizationRequest
 */
export type GetOrganizationRequest = Message<"bff.v1.GetOrganizationRequest"> & {
  /**
   * 組織ID
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message bff.v1.GetOrganizationRequest.
 * Use `create(GetOrganizationRequestSchema)` to create a new message.
 */
export const GetOrganizationRequestSchema: GenMessage<GetOrganizationRequest> = /*@__PURE__*/
  messageDesc(file_bff_v1_common, 8);

/**
 * 組織取得のレスポンス
 *
 * @generated from message bff.v1.GetOrganizationResponse
 */
export type GetOrganizationResponse = Message<"bff.v1.GetOrganizationResponse"> & {
  /**
   * 組織
   *
   * @generated from field: bff.v1.Organization organization = 1;
   */
  organization?: Organization;
};

/**
 * Describes the message bff.v1.GetOrganizationResponse.
 * Use `create(GetOrganizationResponseSchema)` to create a new message.
 */
export const GetOrganizationResponseSchema: GenMessage<GetOrganizationResponse> = /*@__PURE__*/
  messageDesc(file_bff_v1_common, 9);

/**
 * ユーザーロール一覧取得のリクエスト
 *
 * @generated from message bff.v1.ListUserRolesRequest
 */
export type ListUserRolesRequest = Message<"bff.v1.ListUserRolesRequest"> & {
  /**
   * プランID
   *
   * @generated from field: int32 plan_id = 1;
   */
  planId: number;
};

/**
 * Describes the message bff.v1.ListUserRolesRequest.
 * Use `create(ListUserRolesRequestSchema)` to create a new message.
 */
export const ListUserRolesRequestSchema: GenMessage<ListUserRolesRequest> = /*@__PURE__*/
  messageDesc(file_bff_v1_common, 10);

/**
 * ユーザーロール一覧取得のレスポンス
 *
 * @generated from message bff.v1.ListUserRolesResponse
 */
export type ListUserRolesResponse = Message<"bff.v1.ListUserRolesResponse"> & {
  /**
   * @generated from field: repeated bff.v1.UserRole user_roles = 1;
   */
  userRoles: UserRole[];
};

/**
 * Describes the message bff.v1.ListUserRolesResponse.
 * Use `create(ListUserRolesResponseSchema)` to create a new message.
 */
export const ListUserRolesResponseSchema: GenMessage<ListUserRolesResponse> = /*@__PURE__*/
  messageDesc(file_bff_v1_common, 11);

/**
 * 契約しているライセンスと紐づくユーザーロール一覧取得のリクエスト
 *
 * @generated from message bff.v1.ListSelectableUserRolesRequest
 */
export type ListSelectableUserRolesRequest = Message<"bff.v1.ListSelectableUserRolesRequest"> & {
};

/**
 * Describes the message bff.v1.ListSelectableUserRolesRequest.
 * Use `create(ListSelectableUserRolesRequestSchema)` to create a new message.
 */
export const ListSelectableUserRolesRequestSchema: GenMessage<ListSelectableUserRolesRequest> = /*@__PURE__*/
  messageDesc(file_bff_v1_common, 12);

/**
 * 契約しているライセンスと紐づくユーザーロール一覧取得のレスポンス
 *
 * @generated from message bff.v1.ListSelectableUserRolesResponse
 */
export type ListSelectableUserRolesResponse = Message<"bff.v1.ListSelectableUserRolesResponse"> & {
  /**
   * @generated from field: repeated bff.v1.SelectableUserRole selectable_user_roles = 1;
   */
  selectableUserRoles: SelectableUserRole[];
};

/**
 * Describes the message bff.v1.ListSelectableUserRolesResponse.
 * Use `create(ListSelectableUserRolesResponseSchema)` to create a new message.
 */
export const ListSelectableUserRolesResponseSchema: GenMessage<ListSelectableUserRolesResponse> = /*@__PURE__*/
  messageDesc(file_bff_v1_common, 13);

/**
 * プランIDからプロダクトを取得するリクエスト
 *
 * @generated from message bff.v1.GetProductByPlanIdRequest
 */
export type GetProductByPlanIdRequest = Message<"bff.v1.GetProductByPlanIdRequest"> & {
  /**
   * プランID
   *
   * @generated from field: int32 plan_id = 1;
   */
  planId: number;
};

/**
 * Describes the message bff.v1.GetProductByPlanIdRequest.
 * Use `create(GetProductByPlanIdRequestSchema)` to create a new message.
 */
export const GetProductByPlanIdRequestSchema: GenMessage<GetProductByPlanIdRequest> = /*@__PURE__*/
  messageDesc(file_bff_v1_common, 14);

/**
 * プランIDからプロダクトを取得するレスポンス
 *
 * @generated from message bff.v1.GetProductByPlanIdResponse
 */
export type GetProductByPlanIdResponse = Message<"bff.v1.GetProductByPlanIdResponse"> & {
  /**
   * @generated from field: bff.v1.Product product = 1;
   */
  product?: Product;
};

/**
 * Describes the message bff.v1.GetProductByPlanIdResponse.
 * Use `create(GetProductByPlanIdResponseSchema)` to create a new message.
 */
export const GetProductByPlanIdResponseSchema: GenMessage<GetProductByPlanIdResponse> = /*@__PURE__*/
  messageDesc(file_bff_v1_common, 15);

/**
 * プラン取得のリクエスト
 *
 * @generated from message bff.v1.GetPlanRequest
 */
export type GetPlanRequest = Message<"bff.v1.GetPlanRequest"> & {
  /**
   * プランID
   *
   * @generated from field: int32 id = 1;
   */
  id: number;
};

/**
 * Describes the message bff.v1.GetPlanRequest.
 * Use `create(GetPlanRequestSchema)` to create a new message.
 */
export const GetPlanRequestSchema: GenMessage<GetPlanRequest> = /*@__PURE__*/
  messageDesc(file_bff_v1_common, 16);

/**
 * プラン取得のレスポンス
 *
 * @generated from message bff.v1.GetPlanResponse
 */
export type GetPlanResponse = Message<"bff.v1.GetPlanResponse"> & {
  /**
   * @generated from field: bff.v1.Plan plan = 1;
   */
  plan?: Plan;
};

/**
 * Describes the message bff.v1.GetPlanResponse.
 * Use `create(GetPlanResponseSchema)` to create a new message.
 */
export const GetPlanResponseSchema: GenMessage<GetPlanResponse> = /*@__PURE__*/
  messageDesc(file_bff_v1_common, 17);

/**
 * ライセンス別ユーザーロール
 *
 * @generated from message bff.v1.SelectableUserRole
 */
export type SelectableUserRole = Message<"bff.v1.SelectableUserRole"> & {
  /**
   * ライセンス
   *
   * @generated from field: bff.v1.License license = 1;
   */
  license?: License;

  /**
   * ユーザーロール
   *
   * @generated from field: repeated bff.v1.UserRoleSetting user_role_setting = 2;
   */
  userRoleSetting: UserRoleSetting[];
};

/**
 * Describes the message bff.v1.SelectableUserRole.
 * Use `create(SelectableUserRoleSchema)` to create a new message.
 */
export const SelectableUserRoleSchema: GenMessage<SelectableUserRole> = /*@__PURE__*/
  messageDesc(file_bff_v1_common, 18);

/**
 * メンバー一覧取得のリクエスト
 *
 * @generated from message bff.v1.ListMembersRequest
 */
export type ListMembersRequest = Message<"bff.v1.ListMembersRequest"> & {
};

/**
 * Describes the message bff.v1.ListMembersRequest.
 * Use `create(ListMembersRequestSchema)` to create a new message.
 */
export const ListMembersRequestSchema: GenMessage<ListMembersRequest> = /*@__PURE__*/
  messageDesc(file_bff_v1_common, 19);

/**
 * メンバー一覧取得のレスポンス
 *
 * @generated from message bff.v1.ListMembersResponse
 */
export type ListMembersResponse = Message<"bff.v1.ListMembersResponse"> & {
  /**
   * @generated from field: repeated bff.v1.Member members = 1;
   */
  members: Member[];
};

/**
 * Describes the message bff.v1.ListMembersResponse.
 * Use `create(ListMembersResponseSchema)` to create a new message.
 */
export const ListMembersResponseSchema: GenMessage<ListMembersResponse> = /*@__PURE__*/
  messageDesc(file_bff_v1_common, 20);

/**
 * メンバーの画像アップロードリクエスト
 *
 * @generated from message bff.v1.UploadMemberImageRequest
 */
export type UploadMemberImageRequest = Message<"bff.v1.UploadMemberImageRequest"> & {
  /**
   * 画像データ
   *
   * @generated from field: bytes image = 1;
   */
  image: Uint8Array;
};

/**
 * Describes the message bff.v1.UploadMemberImageRequest.
 * Use `create(UploadMemberImageRequestSchema)` to create a new message.
 */
export const UploadMemberImageRequestSchema: GenMessage<UploadMemberImageRequest> = /*@__PURE__*/
  messageDesc(file_bff_v1_common, 21);

/**
 * メンバーの画像アップロードレスポンス
 *
 * @generated from message bff.v1.UploadMemberImageResponse
 */
export type UploadMemberImageResponse = Message<"bff.v1.UploadMemberImageResponse"> & {
  /**
   * 画像URL
   *
   * @generated from field: string image_url = 1;
   */
  imageUrl: string;
};

/**
 * Describes the message bff.v1.UploadMemberImageResponse.
 * Use `create(UploadMemberImageResponseSchema)` to create a new message.
 */
export const UploadMemberImageResponseSchema: GenMessage<UploadMemberImageResponse> = /*@__PURE__*/
  messageDesc(file_bff_v1_common, 22);

/**
 * 企業許可メールドメイン取得のリクエスト
 *
 * @generated from message bff.v1.GetCompanyAllowedMailDomainsRequest
 */
export type GetCompanyAllowedMailDomainsRequest = Message<"bff.v1.GetCompanyAllowedMailDomainsRequest"> & {
  /**
   * 企業ID
   *
   * @generated from field: string companyId = 1;
   */
  companyId: string;
};

/**
 * Describes the message bff.v1.GetCompanyAllowedMailDomainsRequest.
 * Use `create(GetCompanyAllowedMailDomainsRequestSchema)` to create a new message.
 */
export const GetCompanyAllowedMailDomainsRequestSchema: GenMessage<GetCompanyAllowedMailDomainsRequest> = /*@__PURE__*/
  messageDesc(file_bff_v1_common, 23);

/**
 * 企業許可メールドメイン取得のレスポンス
 *
 * @generated from message bff.v1.GetCompanyAllowedMailDomainsResponse
 */
export type GetCompanyAllowedMailDomainsResponse = Message<"bff.v1.GetCompanyAllowedMailDomainsResponse"> & {
  /**
   * 企業許可メールドメイン
   *
   * @generated from field: bff.v1.CompanyAllowedMailDomain allowed_mail_domain = 1;
   */
  allowedMailDomain?: CompanyAllowedMailDomain;
};

/**
 * Describes the message bff.v1.GetCompanyAllowedMailDomainsResponse.
 * Use `create(GetCompanyAllowedMailDomainsResponseSchema)` to create a new message.
 */
export const GetCompanyAllowedMailDomainsResponseSchema: GenMessage<GetCompanyAllowedMailDomainsResponse> = /*@__PURE__*/
  messageDesc(file_bff_v1_common, 24);

/**
 * @generated from message bff.v1.EmailVerifiedRequest
 */
export type EmailVerifiedRequest = Message<"bff.v1.EmailVerifiedRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message bff.v1.EmailVerifiedRequest.
 * Use `create(EmailVerifiedRequestSchema)` to create a new message.
 */
export const EmailVerifiedRequestSchema: GenMessage<EmailVerifiedRequest> = /*@__PURE__*/
  messageDesc(file_bff_v1_common, 25);

/**
 * @generated from message bff.v1.EmailVerifiedResponse
 */
export type EmailVerifiedResponse = Message<"bff.v1.EmailVerifiedResponse"> & {
  /**
   * @generated from field: bff.v1.EmailVerifiedStatus status = 1;
   */
  status: EmailVerifiedStatus;
};

/**
 * Describes the message bff.v1.EmailVerifiedResponse.
 * Use `create(EmailVerifiedResponseSchema)` to create a new message.
 */
export const EmailVerifiedResponseSchema: GenMessage<EmailVerifiedResponse> = /*@__PURE__*/
  messageDesc(file_bff_v1_common, 26);

/**
 * @generated from message bff.v1.ListSessionsRequest
 */
export type ListSessionsRequest = Message<"bff.v1.ListSessionsRequest"> & {
};

/**
 * Describes the message bff.v1.ListSessionsRequest.
 * Use `create(ListSessionsRequestSchema)` to create a new message.
 */
export const ListSessionsRequestSchema: GenMessage<ListSessionsRequest> = /*@__PURE__*/
  messageDesc(file_bff_v1_common, 27);

/**
 * @generated from message bff.v1.ListSessionsResponse
 */
export type ListSessionsResponse = Message<"bff.v1.ListSessionsResponse"> & {
  /**
   * @generated from field: repeated bff.v1.SessionInformation sessions = 1;
   */
  sessions: SessionInformation[];
};

/**
 * Describes the message bff.v1.ListSessionsResponse.
 * Use `create(ListSessionsResponseSchema)` to create a new message.
 */
export const ListSessionsResponseSchema: GenMessage<ListSessionsResponse> = /*@__PURE__*/
  messageDesc(file_bff_v1_common, 28);

/**
 * @generated from message bff.v1.FinishSessionRequest
 */
export type FinishSessionRequest = Message<"bff.v1.FinishSessionRequest"> & {
  /**
   * @generated from field: string session_key = 1;
   */
  sessionKey: string;
};

/**
 * Describes the message bff.v1.FinishSessionRequest.
 * Use `create(FinishSessionRequestSchema)` to create a new message.
 */
export const FinishSessionRequestSchema: GenMessage<FinishSessionRequest> = /*@__PURE__*/
  messageDesc(file_bff_v1_common, 29);

/**
 * @generated from message bff.v1.FinishSessionResponse
 */
export type FinishSessionResponse = Message<"bff.v1.FinishSessionResponse"> & {
};

/**
 * Describes the message bff.v1.FinishSessionResponse.
 * Use `create(FinishSessionResponseSchema)` to create a new message.
 */
export const FinishSessionResponseSchema: GenMessage<FinishSessionResponse> = /*@__PURE__*/
  messageDesc(file_bff_v1_common, 30);

/**
 * @generated from service bff.v1.BffCommonService
 */
export const BffCommonService: GenService<{
  /**
   * @generated from rpc bff.v1.BffCommonService.ListProducts
   */
  listProducts: {
    methodKind: "unary";
    input: typeof ListProductsRequestSchema;
    output: typeof ListProductsResponseSchema;
  },
  /**
   * @generated from rpc bff.v1.BffCommonService.GetProductByPlanId
   */
  getProductByPlanId: {
    methodKind: "unary";
    input: typeof GetProductByPlanIdRequestSchema;
    output: typeof GetProductByPlanIdResponseSchema;
  },
  /**
   * @generated from rpc bff.v1.BffCommonService.ListUserRoles
   */
  listUserRoles: {
    methodKind: "unary";
    input: typeof ListUserRolesRequestSchema;
    output: typeof ListUserRolesResponseSchema;
  },
  /**
   * @generated from rpc bff.v1.BffCommonService.ListSelectableUserRoles
   */
  listSelectableUserRoles: {
    methodKind: "unary";
    input: typeof ListSelectableUserRolesRequestSchema;
    output: typeof ListSelectableUserRolesResponseSchema;
  },
  /**
   * @generated from rpc bff.v1.BffCommonService.GetMemberProfile
   */
  getMemberProfile: {
    methodKind: "unary";
    input: typeof GetMemberProfileRequestSchema;
    output: typeof GetMemberProfileResponseSchema;
  },
  /**
   * @generated from rpc bff.v1.BffCommonService.UpdateOwnMemberProfile
   */
  updateOwnMemberProfile: {
    methodKind: "unary";
    input: typeof UpdateOwnMemberProfileRequestSchema;
    output: typeof UpdateOwnMemberProfileResponseSchema;
  },
  /**
   * @generated from rpc bff.v1.BffCommonService.GetOrganization
   */
  getOrganization: {
    methodKind: "unary";
    input: typeof GetOrganizationRequestSchema;
    output: typeof GetOrganizationResponseSchema;
  },
  /**
   * @generated from rpc bff.v1.BffCommonService.GetPlan
   */
  getPlan: {
    methodKind: "unary";
    input: typeof GetPlanRequestSchema;
    output: typeof GetPlanResponseSchema;
  },
  /**
   * @generated from rpc bff.v1.BffCommonService.ListMembers
   */
  listMembers: {
    methodKind: "unary";
    input: typeof ListMembersRequestSchema;
    output: typeof ListMembersResponseSchema;
  },
  /**
   * @generated from rpc bff.v1.BffCommonService.UploadMemberImage
   */
  uploadMemberImage: {
    methodKind: "unary";
    input: typeof UploadMemberImageRequestSchema;
    output: typeof UploadMemberImageResponseSchema;
  },
  /**
   * @generated from rpc bff.v1.BffCommonService.GetCompanyAllowedMailDomains
   */
  getCompanyAllowedMailDomains: {
    methodKind: "unary";
    input: typeof GetCompanyAllowedMailDomainsRequestSchema;
    output: typeof GetCompanyAllowedMailDomainsResponseSchema;
  },
  /**
   * @generated from rpc bff.v1.BffCommonService.EmailVerified
   */
  emailVerified: {
    methodKind: "unary";
    input: typeof EmailVerifiedRequestSchema;
    output: typeof EmailVerifiedResponseSchema;
  },
  /**
   * @generated from rpc bff.v1.BffCommonService.ListSessions
   */
  listSessions: {
    methodKind: "unary";
    input: typeof ListSessionsRequestSchema;
    output: typeof ListSessionsResponseSchema;
  },
  /**
   * @generated from rpc bff.v1.BffCommonService.FinishSession
   */
  finishSession: {
    methodKind: "unary";
    input: typeof FinishSessionRequestSchema;
    output: typeof FinishSessionResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_bff_v1_common, 0);

